/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable import/prefer-default-export */
export class IntervalUtils {
  static setIntervalForFunctionWithResponse = (
    intervalName: string,
    repeat: number,
    time: number,
    functionToRepeat: any,
    callback: any,
  ) => {
    let count = 0;
    let response = null as any;
    // @ts-ignore
    window[intervalName] = setInterval(async () => {
      if (count < repeat) {
        console.log(count);
        response = await functionToRepeat();
      } else {
        IntervalUtils.clearInterval(intervalName);
      }
      if (response !== null) {
        IntervalUtils.clearInterval(intervalName);
        callback(response);
      } else {
        count += 1;
      }
    }, time);
    return () => IntervalUtils.clearInterval(intervalName);
  };

  static clearInterval = (intervalName: string) => {
    // @ts-ignore
    clearInterval(window[intervalName]);
  };
}
